export default {
  methods: {
    scrollToId(itemId) {
      let element = document.getElementById(itemId)
      element.scrollIntoView({block: 'start', behavior: 'smooth'})
    },
  },
}